
export function initFlipTexts(selector = '[data-flip-text]') {
	const flipEls = document.querySelectorAll(selector);
	flipEls.forEach((flipEl) => {
		initFlipText(flipEl);
	});
}

function initFlipText(flipEl) {

	setMinHeight(flipEl);

	window.addEventListener('resize', ()=>{
		setMinHeight(flipEl);
	});


	let timing = parseInt( flipEl.dataset.flipText );
	if(!timing) timing = 3000;

	advanceFlipText(flipEl);

	setInterval(()=>{
		advanceFlipText(flipEl);
	}, timing);

	flipEl.classList.add('init');
}

function setMinHeight(flipEl) {
	const flipItems = flipEl.querySelectorAll('[data-flip-item]');
	let minHeight = 0;
	flipItems.forEach( flipItem => {
		if(flipItem.offsetHeight > minHeight) {
			minHeight = flipItem.offsetHeight;
		}
	});

	flipEl.style = `min-height:${minHeight}px;`;
}

function advanceFlipText(flipEl) {

	if(undefined == flipEl.dataset.active) { // First time init
		const firstFlipItem = flipEl.querySelector('[data-flip-item]');
		firstFlipItem.classList.add('active');
		flipEl.dataset.active = 0;
		return;
	}

	let active = parseInt( flipEl.dataset.active );
	const flipItems = flipEl.querySelectorAll('[data-flip-item]');

	flipItems.forEach( flipItem => {
		flipItem.classList.remove('outgoing');
	});

	flipItems[active].classList.add('outgoing');

	flipItems.forEach( flipItem => {
		flipItem.classList.remove('active');
	});

	if(undefined !== flipItems[active + 1]) {
		flipItems[active + 1].classList.add('active');
		active = active + 1;
	}
	else {
		flipItems[0].classList.add('active');
		active = 0;
	}

	flipEl.dataset.active = active;
}